// src/hooks/useCourseId.js
export default function useCourseId() {
  // Later you can switch to router params here
  return process.env.REACT_APP_DEFAULT_COURSE_ID;
}
